<template>
  <div class="paymentForm">
    <!-- Payment details -->
    <div class="details">
      <div>
        <span v-if="cardObj && cardObj.firstName">{{cardObj.firstName}}</span>
        <span v-if="cardObj && cardObj.lastName">{{cardObj.lastName}}</span>
      </div>
      <div v-if="cardObj && cardObj.maskedCardNumber">{{cardObj.maskedCardNumber}}</div>
    </div>
    
    <!-- Button and modal -->
    <div class="paymentBttn">
      <button v-on:click.prevent class="btn btn-md btn-primary" style="white-space: nowrap; margin-left: 1rem;" data-bs-toggle="modal" :data-bs-target="'#' + modalName">Add Credit Card</button>

      <!-- Form element -->
      <input type="hidden" v-model="cardObjID" :name="methodInputName()" />

      <!-- Modal -->
      <div class="paymentModal modal fade" :id="modalName" tabindex="-1" :aria-labelledby="modalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" :id="modalLabel">Credit Card Details</h5>
            </div>
            <div class="modal-body">
              <!-- Name on card -->
              <label>Name on Card</label>
              <div class="input-group mb-3">
                <input type="text" name="firstName" v-model="firstName" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="First name" />
                <input type="text" name="lastName" v-model="lastName" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="Last name" :class="{ 'is-invalid': (errors['paymentMethod.LastName']) }" />
              </div>

              <!-- Card number -->
              <div class="mb-3">
                <label>Card Number</label>
                <input type="number" v-model="cc_cardNumber" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="Card number" :class="{ 'is-invalid': (errors['paymentMethod.CardNumber'] || errors['Api Error']) }" />
              </div>

              <!-- Exp Date, CVV -->
              <div class="row row-cols-2">
                <!-- CVV -->
                <div class="mb-3 col">
                  <label>CVV</label>
                  <input type="number" v-model="cc_cvv" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="CVV" :class="{ 'is-invalid': (errors['paymentMethod.Cvv'] || errors['Api Error']) }" />
                </div>

                <!-- Expiration -->
                <div class="mb-3 col">
                  <label>Exp. Date</label>
                  <div class="input-group">
                    <input type="number" v-model="cc_expMonth" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="MM" :class="{ 'is-invalid': (errors['paymentMethod.expirationMonth'] || errors['paymentMethod.ExpirationMonth'] || errors['Api Error']) }" min="1" max="12" />
                    <input type="number" v-model="cc_expYear" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="YY" :class="{ 'is-invalid': (errors['paymentMethod.expirationYear'] || errors['paymentMethod.ExpirationYear'] || errors['Api Error']) }" min="0" max="99" />
                  </div>
                </div>
              </div>

              <!-- Billing ZIP -->
              <div class="mb-3">
                <label>Zip Code</label>
                <input type="number" name="zip" v-model="cc_zip" :disabled="isSubmitting" class="form-control form-control-sm" placeholder="Zip Code" />
              </div>

              <!-- Api Error -->
              <div v-if="apiError" class="mb-3"><strong class="text-danger">We couldn't add this card. Please check the details and try again.</strong></div>

              <!-- ReCaptcha -->
              <div class="g-recaptcha mb-3" :id="reCaptchaName"></div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" v-on:click.prevent="createCardPayment">{{saveBtnLabel}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    apiKey: { type: String, required: true },
    clientIp: { type: String, required: true },
    customerId: { type: Number, required: true },
    email: { type: String, default: '' },
    group: { type: Object, required: true },
    legalEntity: { type: Object, required: true },
    recaptchaKey: { type: String, required: true },
  },
  data: function() {
    return {
      isSubmitting: false,
      errorCode: false,
      errors: {},
      apiError: false,
  
      cardObj: {},
      cardObjID: '',
      paymentCards: {}, // Cards that exist on the legal entity, used for re-populating the payment method

      // Card details
      cc_cardNumber: '',
      cc_expMonth: '',
      cc_expYear: '',
      cc_cvv: '',
      cc_zip: '',
      firstName: '',
      lastName: '',
    };
  },
  computed: {
    modalLabel: function() { return 'entity-' + this.legalEntity.id + '-modalLabel'; },
    modalName: function() { return 'entity-' + this.legalEntity.id + '-modal'; },
    reCaptchaName: function() { return 'entity-' + this.legalEntity.id + '-captcha'; },
    saveBtnLabel: function() { return (this.isSubmitting) ? 'Processing...' : 'Add Payment' },
    subCount: function() { return this.legalEntity.subscriptions.length; },
  },
  methods: {
    clearForm: function() {
      this.cc_cardNumber = '';
      this.cc_expMonth = '';
      this.cc_expYear = '';
      this.cc_cvv = '';
      this.cc_zip = '';
      this.firstName = '';
      this.lastName = '';
    },
    createCardPayment: function() {
      this.isSubmitting = true;
      this.errors = {};
      this.apiError = false;

      axios.post('https://payments.subscriptionplatform.com/api/paymentsv2', {
        customerID: this.customerId,
        publicApiKey: this.apiKey,
        cardNumber: this.cc_cardNumber,
        firstName: this.firstName,
        lastName: this.lastName,
        expirationMonth: this.cc_expMonth,
        expirationYear: this.cc_expYear,
        cvv: this.cc_cvv,
        email: this.email,
        clientIP: this.clientIp,
        makeDefault: true,
        recaptcha: this.$root.googleReCaptchaToken,
        postalZip: this.cc_zip,
      })
      .then(function(response) {        
        this.cardObj = response.data;
        this.cardObjID = response.data.id;

        // Tell the parent to re-fetch the customer
        grecaptcha.reset();

        // Clear the form
        this.clearForm();

        // Close the modal
        bootstrap.Modal.getInstance(document.getElementById(this.modalName)).hide();
      }.bind(this))
      .catch(function(error) {
        // Bugsnag.notify(new Error('Error submitting payment'), function(e) {
        //   e.addMetadata('response', error.response)
        // });

        if(error.response) {
          this.errorCode = error.response.data.ErrorId;

          console.warn('Error ID: ' + error.response.data.ErrorId);
          if(error.response.data.Errors) {
            error.response.data.Errors.forEach(err => {
              if(err.Value) console.warn(err.Value + ' (' + err.Key + ')');
              else console.warn(err.Key);
              this.errors[err.Key] = (err.Value) ? err.Value : true;
            });
          }

          // Throw an alert if we get a "Message" back
          if(error.response.data.Message) { alert(error.response.data.Message); }
        }
        else { console.error(error); }

        // A response with a Message already gets an alert, so only show the generic error otherwise (including network failures)
        if(!error.response || !error.response.data.Message) this.apiError = true;

      }.bind(this))
      .finally(function() {
        this.isSubmitting = false;
        grecaptcha.reset(); // Reset the catcha

        // TODO: Close the modal
      }.bind(this));
    },
    enabledCaptcha: function() {
      console.log('Captcha: ' + this.legalEntity.id);
      var data = {
        'sitekey': this.recaptchaKey,
        'callback': verifyCallback,
      };
      grecaptcha.render('entity-' + this.legalEntity.id + '-captcha', data);
    },
    getLegalEntity: function() {
      this.isSubmitting = true;
      axios.post('/api/v1/entity/' + this.legalEntity.id, {
          group: this.group.id,
        })
        .then(function(response) {
          this.paymentCards   = response.data.data.fb_payment_methods.creditCards;

          response.data.data.fb_payment_methods.creditCards.forEach(card => {
            if(card.isDefault == true) {
              this.cardObj = card;
              this.cardObjID = card.id;
            }
          });
        }.bind(this))
        .catch(function(error) {
          this.entity = false;

          if(error.response) {
            this.errorCode = error.response.data.ErrorId;
            this.errors = error.response.data.Errors;
            console.error(error.response.data);
          }
          else { console.error(error); }
        }.bind(this))
        .finally(function() { this.isSubmitting = false; }.bind(this))
    },
    methodInputName: function() { return 'paymentMethod[' + this.legalEntity.id + ']'; },
  },
  mounted: function() {
    // Fetch the legal entity so we can repopulate the payment details
    this.getLegalEntity();
  },
}
</script>